import React from "react";
import { PiArrowCircleLeft } from "react-icons/pi";
import { PiUserCircle } from "react-icons/pi";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Header() {
  const [isActiveHome, setIsActiveHome] = useState(false);
  const [isActiveRegistrationEmployees, setIsActiveRegistrationEmployees] =
    useState(false);
  const [isActiveIndex, setIsActiveIndex] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsActiveHome(location.pathname === "/home");
    setIsActiveRegistrationEmployees(
      location.pathname === "/user-registration-employees"
    );
    setIsActiveIndex(location.pathname === "/");
  }, [location]);

  return (
    <header className=" bg-gradient-to-r from-amber-600 to-amber-800 border-none lg:w-full w-full" data-testid="header">
      <div className=" container mx-auto px-4 py-2 lg:py-4 flex items-center" data-testid="header-container">
        {/* Primera columna */}
        <div className="flex-1 flex justify-start" data-testid="header-left-column">
          {isActiveIndex ? (
            // En la página inicial, el logo va en la primera columna
            <a href="/" data-testid="header-logo-link">
              <div className="md:w-48 flex-shrink-0" data-testid="header-logo">
                <img
                  className="h-14 lg:h-18 lg:w-18"
                  src="/parqueo.png"
                  alt="logo"
                  data-testid="header-logo-img"
                />
              </div>
            </a>
          ) : (
            // En el resto de páginas, el botón de retroceso o usuario va en la primera columna
            <>
              {isActiveHome ? (
                <a href="/user-administration">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 text-gray-900 hover:text-purple-600">
                    <PiUserCircle className="w-12 h-12 lg:w-16 lg:h-16" />
                  </div>
                </a>
              ) : (
                <button
                  onClick={() => {
                    // Check if we're in a detail view of one of the critical first-level components
                    const isUserDetail = location.pathname.includes('/users-administration-list');
                    const isTicketDetail = location.pathname.includes('/TicketsTable');
                    const isAprendizDetail = location.pathname.includes('/user-registration-request');
                    const isAdminsButtons = location.pathname.includes('/users-administration');
                    const isParking = location.pathname.includes('/dashboard');
                    const isQrCode = location.pathname.includes('/qr-generator');

                    // If we're in a detail view, navigate to home, otherwise use browser history
                    if (isUserDetail || isAprendizDetail) {
                      navigate('/users-administration');
                    } else if (isActiveRegistrationEmployees) {
                      navigate(-2);
                    } else if (isTicketDetail || isAdminsButtons || isParking || isQrCode) {
                      navigate('/home')
                    }
                     else {
                      navigate(-1);
                    }
                  }}
                  data-testid="header-back-button"
                >
                  <div className="w-12 h-12 lg:w-16 lg:h-16 text-gray-900 hover:text-purple-600">
                    <PiArrowCircleLeft className="w-12 h-12 lg:w-16 lg:h-16" />
                  </div>
                </button>
              )}
            </>
          )}
        </div>

        {/* Columna central - vacía para mantener el espaciado */}
        <div className="flex-1 flex justify-center" data-testid="header-center-column">
        </div>

        {/* Tercera columna */}
        <div className="flex-1 flex justify-end" data-testid="header-right-column">
          {isActiveIndex ? (
            // En la página inicial, el enlace "Ver estado del registro" va en la tercera columna
            <a 
              className="text-sm lg:text-base font-semibold hover:underline text-indigo-700 dark:text-indigo-400 text-center" 
              href="/estado-solicitud-registro"
              data-testid="header-registration-status-link"
            >

            </a>
          ) : (
            // En el resto de páginas, el logo va en la tercera columna
            <a href="/" data-testid="header-logo-link-right">
              <div className="md:w-48 flex-shrink-0" data-testid="header-logo-right">
                <img
                  className="h-14 lg:h-18 lg:w-18"
                  src="/parqueo.png"
                  alt="logo"
                  data-testid="header-logo-img-right"
                />
              </div>
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
export { Header };
